export default "/fonts/vendor/@fontsource/lato/files/lato-latin-ext-400-normal.woff?221746f6ba5760746446a24dd4e05a24";